import React, { useMemo } from "react";
import { Tab, Tabs } from "@bloomberg/media-ui-core";
import styles from "./styles.module.css";
import { BENCHMARK_CHART_TIME_RANGES } from "~constants";
import { useTranslateMessage } from "~utils/i18n";

const TABS_CONTAINER_WIDTH_PERCENT = 100;
const NUMBER_OF_TABS = 5;

type ChartTimeRangeType = (typeof BENCHMARK_CHART_TIME_RANGES)[number];
const MAPPED_CHART_TIME_RANGE_TO_TRANSLATION_KEY: Record<
  ChartTimeRangeType,
  string
> = {
  "1M": "1m",
  "6M": "6m",
  YTD: "ytd",
  "1Y": "1y",
  "5Y": "5y",
};

export function getTranslatedText(selected: ChartTimeRangeType): string {
  return MAPPED_CHART_TIME_RANGE_TO_TRANSLATION_KEY[selected] ?? "";
}

export function TimeRangeTabs({
  selected,
  onChange,
}: {
  selected: ChartTimeRangeType;
  onChange: (chartTimeRange: string, index?: number) => void;
}) {
  const translate = useTranslateMessage();

  const translatedTabs = useMemo(() => {
    return BENCHMARK_CHART_TIME_RANGES.map((chartTimeRange) => {
      const translationId = getTranslatedText(chartTimeRange);
      const translatedText = translate({
        id: translationId as keyof typeof translate,
        defaultMessage: chartTimeRange,
      });

      return {
        type: chartTimeRange,
        text: translatedText,
      };
    });
  }, [translate]);

  return (
    <Tabs
      className={styles.tabs}
      size="small"
      variant="gliding"
      onTabSwitch={onChange}
      width={`calc(${TABS_CONTAINER_WIDTH_PERCENT}% / ${NUMBER_OF_TABS})`}
    >
      {translatedTabs.map(({ type, text }) => (
        <Tab key={type} title={text} isActive={selected === type}>
          <></>
        </Tab>
      ))}
    </Tabs>
  );
}
